module.exports = __webpack_public_path__ + "assets/0bf8f4b85079f2ad06cbb12d25ec39da.png";